import type { HashtagCampaignCatalogItem } from '@/types/hashtag.types';

const SESSION_KEY = 'measure-ease:hashtag-campaigns';

export function loadHashtagCampaignsFromSession(): HashtagCampaignCatalogItem[] {
  try {
    const raw = sessionStorage.getItem(SESSION_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as HashtagCampaignCatalogItem[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

export function saveHashtagCampaignsToSession(campaigns: HashtagCampaignCatalogItem[]): void {
  sessionStorage.setItem(SESSION_KEY, JSON.stringify(campaigns));
}

export function upsertHashtagCampaignInSession(campaign: HashtagCampaignCatalogItem): void {
  const list = loadHashtagCampaignsFromSession();
  const idx = list.findIndex(c => c.hashtag_campaign_code === campaign.hashtag_campaign_code);
  if (idx >= 0) {
    list[idx] = campaign;
  } else {
    list.push(campaign);
  }
  saveHashtagCampaignsToSession(list);
}

export function clearHashtagCampaignsSession(): void {
  sessionStorage.removeItem(SESSION_KEY);
}
